import React from 'react';
import {Form, Edit, Quote, List} from 'components';
import {useNamedSelector} from 'helpers';

export function BeliefsInquiry3() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'beliefs-inquiry-3' })}>
      <List tiny-gutter>
        <List.Title>Now that you have a better idea of the positive and negative beliefs you hold onto, you can start thinking about which beliefs you want to keep and which you want to discard.</List.Title>
        <List.Title>How might you change the limiting beliefs which are no longer useful to you?</List.Title>
        <Edit name="4" />
        <Edit name="5" />
        <Edit name="6" />
        <List.Title>Which new beliefs will allow you to grow?</List.Title>
        <Edit name="7" />
        <Edit name="8" />
        <Edit name="9" />
        <List.Title>How can you support and prove your new positive beliefs?</List.Title>
        <Edit name="10" />
        <Edit name="11" />
        <Edit name="12" />
        <List.Group>
          <p>To go back to our grocery store metaphor, it's one thing to choose which beliefs will be good for you and which you want to pass by, and another thing entirely to take home those bags of beliefs and incorporate them in your life. This is a great moment to talk with someone who knows you well and tell them about what you've discovered. Ask them to give you non-judgmental feedback, and then brainstorm ways that you can begin to incorporate the more nourishing beliefs into your life.</p>
          <p>Select the beliefs that you would most like to have about yourself at a deep inner level. Pretend as if you already believe this to be true. Write down your new beliefs, and then the behavior/actions you'll engage in to keep them in place.</p>
        </List.Group>
        <List.Group>
          <Quote author="David O. McKay">
            If the things we believe are different than the things we do, there can be no true happiness.
          </Quote>
        </List.Group>
      </List>
    </Form>
  );
}
